module.exports = __webpack_public_path__ + "static/media/cacFoodTable.ffd75b4b.jpg";